'use client';

import { useEffect } from 'react';

export default function useParallaxDots() {
  useEffect(() => {
    const update = () => {
      const scrollY = window.scrollY;
      const dots = document.querySelectorAll('[data-parallax]');
      dots.forEach(dot => {
        const speed = parseFloat(
          getComputedStyle(dot).getPropertyValue('--speed') || '0.5'
        );
        
        // Get rotation data if available
        const hasRotation = dot.hasAttribute('data-rotation');
        let rotationStyle = '';
        
        if (hasRotation) {
          const rotationDir = parseFloat(
            getComputedStyle(dot).getPropertyValue('--rotation-dir') || '1'
          );
          const rotationSpeed = parseFloat(
            getComputedStyle(dot).getPropertyValue('--rotation-speed') || '0.1'
          );
          
          // Add rotation based on scroll position
          const rotationAngle = (scrollY * rotationSpeed * rotationDir) % 360;
          rotationStyle = ` rotate(${rotationAngle}deg)`;
        }
        
        // Apply transform with both translation and rotation
        dot.setAttribute(
          'style',
          `${dot.getAttribute('style')}; transform: translateY(${scrollY * speed}px)${rotationStyle};`
        );
      });
    };

    // Run update once on load
    update();
    
    window.addEventListener('scroll', update);
    return () => window.removeEventListener('scroll', update);
  }, []);
} 